import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { imgUrl } from '../../../common/utilities/ImgUrl';
import { classes, cssClass } from '../../../style';
import { IUserInfo } from '../../../ts/models/IUserInfo';

import { SiteUrlsProps } from '../../selectors/SiteUrlsSelectors';

import { CardTextAndLink } from './CardTextAndLink';
import { CardViewStyles } from './CardViewStyles';

const cssPrefix = 'FlowThumbnail';

const rootClass = cssClass(cssPrefix, 'root', {
  color: 'inherit',
  textDecoration: 'none',
  $nest: {
    '&:hover': {
      color: 'inherit',
      textDecoration: 'none',
    }
  }
});

const iconClass = cssClass(cssPrefix, 'icon', {
  backgroundImage: imgUrl('spaces_masthead_flow.svg')
});

export interface FlowThumbnailProps extends SiteUrlsProps {
  readonly hoveredOrSelected: boolean;
  readonly navigateUrl: string;
  readonly owner: IUserInfo;
}

export class FlowThumbnail extends React.Component<FlowThumbnailProps> {

  public render() {
    const containerClass = this.props.hoveredOrSelected ? CardViewStyles.CustomThumbnailHover : CardViewStyles.CustomThumbnail;
    return (
      <a className={classes(containerClass, rootClass)} href={this.props.navigateUrl}>
        <div>
          <div className={CardViewStyles.CustomThumbnailTopContainer}>
            <div className={classes(CardViewStyles.CustomThumbnailImg, iconClass)} title={Messages.flow()} />
          </div>
        </div>
        <div onClick={this.stopPropagation}>
          <CardTextAndLink
            text={Messages.flowCardOwnedBy()}
            url={this.props.urls.userContentUrl(this.props.owner.username, this.props.owner.domainName)}
            urlDisplayName={this.props.owner.displayName}
          />
        </div>
      </a>
    );
  }

  private stopPropagation = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    return false;
  }

}
